import { LoadingIndicator, LoadingSkeleton } from '#lib/components/loading.jsx';
import { useState } from 'react';
import useAdmin from './use-admin.js';
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';
import './pagination.css';
import ManageControls from '#components/manage-controls.jsx';
import { addClasses } from '#lib/helpers/class.js';

const itemsPerPage = 20;
const keys = [
    'firstName',
    'lastName',
    'companyName',
    'email',
    'billingAddress',
    'civic',
    'city',
    'province',
    'country',
    'postalCode',
    'taxIdCode',
    'vatNumber',
    'itineraries',
    'publishedItineraries',
    'datePurchase',
    'packageId',
    'price'
];

export default function AdminPanel() {
    const { data, isLoading } = useAdmin();
    const [itemOffset, setItemOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    if (isLoading)
        return (
            <LoadingSkeleton className={addClasses('h-screen flex items-center justify-center fixed inset-4 bg-white')}>
                <LoadingIndicator />
            </LoadingSkeleton>
        );

    const endOffset = itemOffset + itemsPerPage;
    const currentItems = data
        .flatMap((account) =>
            account.purchases.map((purchase) => {
                const { purchases, ...rest } = account;
                return { ...rest, ...purchase };
            })
        )
        .sort((a, b) => {
            const aDate = new Date(a.datePurchase).getTime();
            const bDate = new Date(b.datePurchase).getTime();
            return bDate - aDate;
        })
        .slice(itemOffset, endOffset);
    const pageCount = Math.ceil(data.length / itemsPerPage);

    const handlePageClick = (page) => {
        setCurrentPage(page);
        const newOffset = (page - 1) * itemsPerPage;
        setItemOffset(newOffset);
    };
    return (
        <main>
            <div className="fixed w-full h-[116px] top-0 left-0 z-50">
                <ManageControls.BarSlot>
                    <p className="text-2xl pt-1"> {_t.admin.title()}</p>
                </ManageControls.BarSlot>
            </div>
            <div className="absolute left-1/2 top-28 -translate-x-1/2 w-screen px-3">
                <div
                    className="shadow-lg rounded-lg mb-4 grid w-full border border-neutral-200 overflow-hidden text-sm"
                    style={{ gridTemplateColumns: `repeat(${keys.length}, minmax(0, auto))` }}
                >
                    <div className="col-span-full grid grid-cols-subgrid border border-neutral-200">
                        {keys.map((key) => (
                            <h1 className="text-left p-1 bg-neutral-100 text-nowrap col-span-1 p-1 font-semibold">
                                {_t.admin[key]()}
                            </h1>
                        ))}
                    </div>

                    {currentItems.map((el) => (
                        <div className="col-span-full grid grid-cols-subgrid">
                            {keys.map((key) => (
                                <span className="text-nowrap col-span-1 text-ellipsis whitespace-nowrap truncate border border-neutral-200 p-1">
                                    {el[key]}
                                </span>
                            ))}
                        </div>
                    ))}
                </div>
                <ResponsivePagination current={currentPage} total={pageCount} onPageChange={handlePageClick} />
            </div>
        </main>
    );
}
